import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function Dashboard() {
  const navigate = useNavigate();

  const [auditType, setAuditType] = useState("tenant");
  const [auditTenantId, setAuditTenantId] = useState("");
  const [auditMemberId, setAuditMemberId] = useState("");

  const [sessionType, setSessionType] = useState("tenant");
  const [sessionTenantId, setSessionTenantId] = useState("");
  const [sessionMemberId, setSessionMemberId] = useState("");

  const [deleteTenantId, setDeleteTenantId] = useState("");
  const [invoiceDeleteTenantId, setInvoiceDeleteTenantId] = useState("");

  // NO MORE addApiKey function needed here!
  // The Viewer.js component will handle the key from the environment variables.

  return (
    <div className="container mt-4">
      <h3 className="mb-4">Audit Dashboard</h3>

      <div className="row g-4">
        {/* ---------------- AUDIT LOG ---------------- */}
        <div className="col-md-4">
          <div className="card shadow-sm">
            <div className="card-header fw-bold">Audit Log</div>
            <div className="card-body">
              <button className="btn btn-primary mb-2" onClick={() => navigate("/audit-log")}>
                View All Audit-log
              </button>
              
              <div className="mb-3 mt-3">
                <div className="form-check form-check-inline">
                  <input type="radio" className="form-check-input" checked={auditType === "tenant"} onChange={() => setAuditType("tenant")} />
                  <label className="form-check-label">Tenant ID</label>
                </div>
                <div className="form-check form-check-inline">
                  <input type="radio" className="form-check-input" checked={auditType === "tenant_member"} onChange={() => setAuditType("tenant_member")} />
                  <label className="form-check-label">Tenant + Member</label>
                </div>
              </div>

              <input type="number" className="form-control mb-2" placeholder="Tenant ID" value={auditTenantId} onChange={(e) => setAuditTenantId(e.target.value)} />
              {auditType === "tenant_member" && (
                <input type="number" className="form-control mb-2" placeholder="Member ID" value={auditMemberId} onChange={(e) => setAuditMemberId(e.target.value)} />
              )}

              <button
                className="btn btn-primary w-100"
                disabled={!auditTenantId || (auditType === "tenant_member" && !auditMemberId)}
                onClick={() => navigate(auditType === "tenant" ? `/audit-log/${auditTenantId}` : `/audit-log/${auditTenantId}/${auditMemberId}`)}
              >
                View Audit Log
              </button>
            </div>
          </div>
        </div>

        {/* ---------------- SESSION LOG ---------------- */}
        <div className="col-md-4">
          <div className="card shadow-sm">
            <div className="card-header fw-bold">Session Log</div>
            <div className="card-body">
              <button className="btn btn-success mb-3" onClick={() => navigate("/session")}>
                View All Session
              </button>

              <div className="mb-3">
                <div className="form-check form-check-inline">
                  <input type="radio" className="form-check-input" checked={sessionType === "tenant"} onChange={() => setSessionType("tenant")} />
                  <label className="form-check-label">Tenant ID</label>
                </div>
                <div className="form-check form-check-inline">
                  <input type="radio" className="form-check-input" checked={sessionType === "tenant_member"} onChange={() => setSessionType("tenant_member")} />
                  <label className="form-check-label">Tenant + Member</label>
                </div>
              </div>

              <input type="number" className="form-control mb-2" placeholder="Tenant ID" value={sessionTenantId} onChange={(e) => setSessionTenantId(e.target.value)} />
              {sessionType === "tenant_member" && (
                <input type="number" className="form-control mb-2" placeholder="Member ID" value={sessionMemberId} onChange={(e) => setSessionMemberId(e.target.value)} />
              )}

              <button
                className="btn btn-success w-100"
                disabled={!sessionTenantId || (sessionType === "tenant_member" && !sessionMemberId)}
                onClick={() => navigate(sessionType === "tenant" ? `/session/${sessionTenantId}` : `/session/${sessionTenantId}/${sessionMemberId}`)}
              >
                View Session Log
              </button>
            </div>
          </div>
        </div>


{/* ---------------- EXPORT LOG ---------------- */}
<div className="col-md-4">
  <div className="card shadow-sm">
    <div className="card-header fw-bold">Export Log</div>
    <div className="card-body">
      <button
        className="btn btn-info mb-3"
        onClick={() => navigate("/excel-export")}
      >
        View All Export Logs
      </button>

      <input
        type="number"
        className="form-control mb-2"
        placeholder="Tenant ID"
        value={sessionTenantId}
        onChange={(e) => setSessionTenantId(e.target.value)}
      />

      <button
        className="btn btn-info w-100"
        disabled={!sessionTenantId}
        onClick={() => navigate(`/excel-export/${sessionTenantId}`)}
      >
        View Export Log
      </button>
    </div>
  </div>
</div>

{/* ---------------- DELETE LOG ---------------- */}
<div className="col-md-4">
  <div className="card shadow-sm">
    <div className="card-header fw-bold">Delete Log</div>
    <div className="card-body">
      <button 
        className="btn btn-danger mb-3" 
        onClick={() => navigate("/application-delete-log")}
      >
        View All Application-delete-log
      </button>

      <input 
        type="number" 
        className="form-control mb-2" 
        placeholder="Tenant ID" 
        value={deleteTenantId} 
        onChange={(e) => setDeleteTenantId(e.target.value)} 
      />

      <button
        className="btn btn-danger w-100"
        disabled={!deleteTenantId}
        onClick={() => navigate(`/application-delete-log/${deleteTenantId}`)}
      >
        View Application Delete Log
      </button>
    </div>
  </div>
</div>

{/* ---------------- INVOICE DELETE LOG ---------------- */}
<div className="col-md-4">
  <div className="card shadow-sm">
    <div className="card-header fw-bold">Invoice Delete Log</div>
    <div className="card-body">
      <button 
        className="btn btn-warning mb-3" 
        onClick={() => navigate("/invoice-delete-log")}
      >
        View All Invoice-delete-log
      </button>

      <input 
        type="number" 
        className="form-control mb-2" 
        placeholder="Tenant ID" 
        value={invoiceDeleteTenantId} 
        onChange={(e) => setInvoiceDeleteTenantId(e.target.value)} 
      />

      <button
        className="btn btn-warning w-100"
        disabled={!invoiceDeleteTenantId}
        onClick={() => navigate(`/invoice-delete-log/${invoiceDeleteTenantId}`)}
      >
        View Invoice Delete Log
      </button>
    </div>
  </div>
</div>
      </div>
    </div>
  );
}

export default Dashboard;